<template>
  <b-modal ref="mdlConfigurazioneMagazzinoDocumentoCausali" :title="title" centered no-close-on-backdrop no-close-on-esc
    hide-header-close size="lg" @ok="onOkMdlContabilitaCausaleDocumento" @show="onShow">
    <b-row>
      <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <span class="sa-label-data">Struttura</span>
        <b-form-select v-model="jsonData.codiceStruttura" :options="strutturaOptions" :value="null"
          value-field="codiceStruttura" text-field="denominazione" @change="onChangeStrutture">
          <template #first>
            <b-form-select-option :value="null" disabled> - Selezionare Struttura - </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="3" lg="3" xl="3">
        <label class="sa-label-data">Codice Tipo Documento</label>
        <span v-if="isReadOnly"> {{ jsonData.codiceTipoDocumento }} </span>
        <b-form-select v-else v-model="jsonData.codiceTipoDocumento" :options="contabilitaTipoDocumentoOptions"
          :value="null" value-field="codiceTipoDocumento" text-field="descrizioneTipoDocumento"
          @input="onInputTipoDocumento">
          <template #first>
            <b-form-select-option :value="null" disabled> - Seleziona Tipo Documento - </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="3" lg="3" xl="3">
        <label class="sa-label-data">Operazione Magazzino</label>
        <span v-if="isReadOnly">{{ formatOperazioneMagazzino(jsonData.operazioneMagazzino) }}</span>
        <b-form-select v-else v-model="jsonData.operazioneMagazzino" :options="operazioneMagazzinoOptions"
          :value="null">
          <template #first>
            <b-form-select-option :value="null" disabled> - Seleziona Tipo Operazione - </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="3" lg="3" xl="3">
        <label class="sa-label-data">Operazione Contabile</label>
        <span v-if="isReadOnly"> {{ formatOperazioneContabile(jsonData.operazioneContabile) }}</span>
        <b-form-select v-else v-model="jsonData.operazioneContabile" :options="operazioneContabileOptions"
          :value="null">
          <template #first>
            <b-form-select-option :value="null" disabled> - Seleziona Operazione Contabile - </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="2" lg="2" xl="2">
        <label class="sa-label-data">Codice Causale</label>
        <span v-if="isReadOnly"> {{ jsonData.codiceCausale }}</span>
        <b-form-input v-else v-model="jsonData.codiceCausale"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="6" lg="6" xl="6">
        <label class="sa-label-data">Descrizione Causale</label>
        <span v-if="isReadOnly"> {{ jsonData.descrizioneCausale }}</span>
        <b-form-input v-else v-model="jsonData.descrizioneCausale"></b-form-input>
      </b-col>

      <b-col cols="12" xs="12" sm="4" md="2" lg="2" xl="2">
        <label class="sa-label-data">Soggetti Collegati</label>
        <span v-if="isReadOnly"> {{ formatSoggettiCollegati(jsonData.soggettiCollegati) }}</span>
        <b-form-select v-else v-model="jsonData.soggettiCollegati" :options="soggettoCollegatiOptions">
          <template #first>
            <b-form-select-option :value="null" disabled> - Seleziona Soggetto - </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="2" lg="2" xl="2">
        <label class="sa-label-data">Stampa Prezzi</label>
        <span v-if="isReadOnly"> {{ formatStampaPrezzo(jsonData.stampaPrezzi) }}</span>
        <b-form-checkbox v-else v-model="jsonData.stampaPrezzi" switch></b-form-checkbox>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="12" lg="12" xl="12">
        <label class="sa-label-data">Documenti Collegati</label>
        <b-row style="max-height: fit-content">
          <b-col cols="4" v-for="doc in tipiDocumentiCollegatiOptions" :key="doc.id">
            <div :class="{ 'sa-badge': true, 'ft-active-class': isActiveClass(doc) }"
              @click="onClickTipoDocumento(doc)">
              <div class="sa-badge-label">{{ doc.descrizioneTipoDocumento }}</div>
              <div class="sa-badge-data">{{ doc.codiceTipoDocumento }}</div>
              <div class="sa-badge-data">{{ doc.tipoDocumento }}</div>
              <div style="margin-top: 5px" v-if="isActiveClass(doc)" @click.stop>
                <hr />
                <b-form-checkbox switch v-model="documentiSelezionati[doc.id].obbligatorio">
                  <span style="font-weight: small">Obbligatorio</span>
                </b-form-checkbox>
                <label>Nota</label>
                <b-form-input v-model="documentiSelezionati[doc.id].note"></b-form-input>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- <template #modal-footer>
			<b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
			<b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickSalvaDocumento">Salva</b-button>
			<b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
		</template> -->
    <modal-error ref="cmpModalError"></modal-error>
  </b-modal>
</template>
<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  mixins: [UtilityMixin, StruttureMixin, ContabilitaMixin],
  components: { ModalError },
  data() {
    return {
      title: null,
      pathResource: "/contabilitadocumentocausali",
      isReadOnly: false,
      rowsTipiDocumento: 0,
      currentPageTipoDocumento: 0,
      forPageTipoDocumento: 3,
      tipiDocumentiCollegatiOptions: [],
      tipiDocumentiSelezionati: [],
      documentiSelezionati: {},
      jsonData: {
        id: null,
        codiceStruttura: null,
        codiceTipoDocumento: null,
        operazioneMagazzino: null,
        operazioneContabile: null,
        descrizioneCausale: null,
        stampaPrezzi: false,
        soggettiCollegati: null,
        documentiCollegati: [],
        denominazioneStruttura: null,
        descrizioneTipoDocumento: null,
      },
      operazioneContabileOptions: [
        {
          text: "Dare",
          value: 1,
          // value: "Dare",
        },
        {
          text: "Avere",
          value: -1,
          // value: "Avere",
        },
        {
          text: "Invariato",
          value: 0,
          // value: "Invariato",
        },
      ],
      tipoDocumentoOptions: [],
      soggettoCollegatiOptions: [
        {
          text: "Cliente",
          value: "CLATT",
        },
        {
          text: "Fornitore",
          value: "FOR",
        },
        {
          text: "Entrambi",
          value: "TTT",
        },
      ],
      operazioneMagazzinoOptions: [
        {
          text: "Scarico",
          value: -1,
        },
        {
          text: "Carico",
          value: 1,
        },
        {
          text: "Invariato",
          value: 0,
        },
      ],
    };
  },
  mounted() {
    this.tipiDocumentiSelezionati = [];
    this.documentiSelezionati = {};
  },
  methods: {
    show(jsonData) {
      let me = this;
      this.title = "Nuova Causale Documento";
      if (jsonData.id) {
        this.title = "Modifica Causale Documento";
        this.contabilitaTipoDocumentoLoadData(jsonData.codiceStruttura);
        this.loadDataContabilitaCausaleDocumento(jsonData.id);
      } else {
        this.resetJsonDataCausaleDocumento();
      }
      this.setPresidio();
      this.loadDataTipiDocumento();
      me.$refs.mdlConfigurazioneMagazzinoDocumentoCausali.show();
    },
    onCloseModal() {
      let me = this;
      me.jsonData = {};
      me.$emit("onCloseModal");
      me.$refs.mdlConfigurazioneMagazzinoDocumentoCausali.hide();
    },
    onClickTipoDocumento(doc) {
      let indexDocSelectable = this.tipiDocumentiSelezionati.indexOf(doc.id);
      if (indexDocSelectable == -1) {
        this.tipiDocumentiSelezionati.push(doc.id);
        this.$set(this.documentiSelezionati, doc.id, { obbligatorio: false, note: "" });
      } else {
        this.tipiDocumentiSelezionati.splice(indexDocSelectable, 1);
        delete this.documentiSelezionati[doc.id];
      }
    },
    isActiveClass(doc) {
      return this.tipiDocumentiSelezionati.indexOf(doc.id) != -1;
    },
    onInputTipoDocumento(input) {
      let documentoTipo = this.contabilitaTipoDocumentoOptions.filter((e) => e.codiceTipoDocumento == input);
      if (documentoTipo[0]) {
        let docTipo = documentoTipo[0];
        this.jsonData.descrizioneTipoDocumento = docTipo.descrizioneTipoDocumento;
        this.jsonData.idTipoDocumento = docTipo.id;
      }
    },
    loadDataContabilitaCausaleDocumento(id) {
      this.tipiDocumentiSelezionati = [];
      this.documentiSelezionati = {};
      UtilityMixin.methods.loadDataResources("/contabilitadocumentocausali/" + id, {}, this.loadDataContabilitaCausaleDocumentoSuccess, this.loadDataContabilitaCausaleDocumentoError);
    },
    loadDataContabilitaCausaleDocumentoSuccess(response) {
      this.jsonData = response.data.data;
      if (this.jsonData.documentiCollegati.length > 0) {
        for (let documentoCollegato of this.jsonData.documentiCollegati) {
          this.tipiDocumentiSelezionati.push(documentoCollegato.idTipoDocumento);
          this.$set(this.documentiSelezionati, documentoCollegato.idTipoDocumento, { note: documentoCollegato.note, obbligatorio: documentoCollegato.obbligatorio });
        }
      }
    },
    loadDataContabilitaCausaleDocumentoError(error) {
      error;
    },

    resetJsonDataCausaleDocumento() {
      this.jsonData = {
        id: null,
        codiceStruttura: null,
        codiceTipoDocumento: null,
        operazioneMagazzino: null,
        operazioneContabile: null,
        descrizioneCausale: null,
        stampaPrezzi: false,
        soggettiCollegati: null,
        documentiCollegati: [],
        denominazioneStruttura: null,
        descrizioneTipoDocumento: null,
        idTipoDocumento: null,
      };
      this.tipiDocumentiSelezionati = [];
      this.documentiSelezionati = {};
    },
    onClickSalvaDocumento() {
      let me = this;
      UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.salvaDocumentoCausaleSuccess, me.salvaDocumentoCausaleError);
    },
    salvaDocumentoCausaleSuccess(response) {
      let me = this;
      response;
      me.$refs.mdlConfigurazioneMagazzinoDocumentoCausali.hide();
      me.$bvToast.toast("Salvataggio avvenuto con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    salvaDocumentoCausaleError(error) {
      let me = this;
      me.$emit("saveDocumentoArticolo", error);
      me.$refs.cmpModalError.show(error.response.data.messaggio);
    },
    validazione() {
      let esito = true;
      let msg = "";
      if (this.jsonData.codiceStruttura == null || this.jsonData.codiceStruttura.trim() == "") {
        msg += "Codice Struttura  non valido ! #";
        esito = false;
      }
      if (this.jsonData.codiceTipoDocumento == null || this.jsonData.codiceTipoDocumento.trim() == "") {
        msg += "Codice Tipo Documento non valido ! #";
        esito = false;
      }
      if (this.jsonData.operazioneContabile == null) {
        msg += "Operazione Contabile non valido ! #";
        esito = false;
      }
      if (this.jsonData.operazioneMagazzino == null) {
        msg += "Operazione Magazzino non valida ! #";
        esito = false;
      }
      if (this.jsonData.descrizioneCausale == null || this.jsonData.descrizioneCausale.trim() == "") {
        msg += "Descrizione  non valida ! #";
        esito = false;
      }
      if (this.jsonData.soggettiCollegati == null || this.jsonData.soggettiCollegati.trim() == "") {
        msg += "Soggetti Collegati  non valido ! #";
        esito = false;
      }
      return { esito: esito, msg: msg };
    },
    generaBtoast(validation) {
      let message = "";
      if (validation.msg) {
        message = validation.msg.split("#");

        const h = this.$createElement;
        const vNodesMsg = h("ul", { style: "margin-left: -18px" }, []);
        message.forEach((element) => {
          if (element.trim() != "") {
            vNodesMsg.children.push({ tag: "li", text: element });
          }
        });
        this.$bvToast.toast([vNodesMsg], {
          title: "Attenzione!",
          autoHideDelay: 5000,
          variant: "danger",
        });
      }
    },
    formatOperazioneMagazzino(value) {
      switch (value) {
        case 1:
          return "Carico";
        case -1:
          return "Scarico";
        case 0:
          return "Invariato";
        default:
          return "N/A";
      }
    },
    formatOperazioneContabile(value) {
      switch (value) {
        case 1:
          return "Dare";
        case -1:
          return "Avere";
        case 0:
          return "Invariato";
        default:
          return "N/A";
      }
    },

    formatStampaPrezzo(value) {
      switch (value) {
        case true:
          return "Sì";
        case false:
          return "No";
        default:
          return value || "N/A";
      }
    },
    formatSoggettiCollegati(value) {
      switch (value) {
        case "CL":
          return "Cliente";
        case "FOR":
          return "Fornitore";
        case "TTT":
          return "Entrambi";
        default:
          return value || "N/A";
      }
    },
    contabilitaTipoDocumentoLoadDataSuccess(response) {
      this.tipoDocumentoOptions = response.data.data;
    },
    onChangeStrutture(value) {
      this.contabilitaTipoDocumentoLoadData(value);
      let struttura = this.strutturaOptions.filter((e) => e.codiceStruttura == value);
      if (struttura[0]) {
        let stru = struttura[0];
        this.jsonData.denominazioneStruttura = stru.denominazione;
      }
      this.loadDataTipiDocumento();
    },
    onShow() {
      let me = this;
      me.struttureLoadData();
    },
    onOkMdlContabilitaCausaleDocumento(bvModalEvent) {
      let me = this;
      bvModalEvent.preventDefault();
      let validation = me.validazione();
      if (!validation.esito) {
        me.generaBtoast(validation);
        return;
      }
      this.openShowModalLoading();
      this.jsonData.documentiCollegati = [];
      if (Object.keys(this.documentiSelezionati).length > 0) {
        for (let documentoId of Object.keys(this.documentiSelezionati)) {
          let obj = {
            idTipoDocumento: documentoId,
            obbligatorio: this.documentiSelezionati[documentoId].obbligatorio,
            note: this.documentiSelezionati[documentoId].note,
          };
          this.jsonData.documentiCollegati.push(obj);
        }
      }
      this.$emit("beforeSave");
      this.saveResource(me.pathResource, me.jsonData, me.saveResourceSuccess, me.saveResourceError); //, me.saveResourceError
    },
    saveResourceSuccess() {
      this.$refs.mdlConfigurazioneMagazzinoDocumentoCausali.hide();
      this.closeShowModalLoading();
      this.$emit("afterSave");
    },
    saveResourceError(error) {
      this.generaBtoast({ msg: error.response.data.messaggio, esito: false });
      this.closeShowModalLoading();
    },
    loadDataTipiDocumento() {
      let me = this;
      me.openShowModalLoading();
      let filtro = {
        codiceStruttura: this.jsonData.codiceStruttura,
      };
      UtilityMixin.methods.loadDataResources("/contabilitadocumentotipo", filtro, me.loadDataTipiDocumentoSuccess, me.loadDataTipiDocumentoError);
    },
    loadDataTipiDocumentoSuccess(response) {
      let me = this;
      me.tipiDocumentiCollegatiOptions = response.data.data.list;
      me.closeShowModalLoading();
    },
    loadDataTipiDocumentoError(error) {
      let me = this;
      error;
      me.contabilitaTipoDocumentoOptions = [];
      me.closeShowModalLoading();
    },
    setPresidio() {
      let tmpPresidio = window.localStorage.getItem("presidio");
      if (tmpPresidio) {
        let presidio = JSON.parse(tmpPresidio);
        this.jsonData.codiceStruttura = presidio.codiceStruttura;
        this.contabilitaTipoDocumentoLoadData(this.jsonData.codiceStruttura);
      }
    },
  },
};
</script>
<style scoped>
.sa-badge {
  max-width: none !important;
  cursor: pointer;
}

.sa-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  background-color: rgba(255, 255, 255, 0.651);
}

.ft-active-class {
  transform: translateY(-2px);
  box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
  border: 1px solid var(--bg-sidebar) !important;
  border-color: var(--bg-sidebar) !important;
  background-color: var(--bg-button-press-color);
}

.ft-active-class:hover {
  box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
  border: 1px solid var(--bg-sidebar) !important;
  border-color: var(--bg-sidebar) !important;
  transform: translateY(-1px);
  background-color: var(--bg-button-press-color);
}
</style>
